// import React from "react";
// import artperfection2 from "../../images/artperfection-2.jpg";
// import artperfection1 from "../../images/artperfection-1.jpg";
// import newssImage1 from "../../images/newss-image1.jpg";
// import newssImage2 from "../../images/newss-image2.jpg";
// import newssImage3 from "../../images/newss-image3.jpg";
// import { BsArrowRight } from "react-icons/bs";
// import "./blog.css";

// const Blog = () => {
//   return (
//     <>
//       <section className="blog bg-accent">
//         <div className="container split flow-content">
//           <div className="blog__img">
//             <div className="blog__imgBox1">
//               <img src={artperfection2} alt="" />
//             </div>
//             <div className="blog__imgBox2">
//               <img src={artperfection1} alt="" />
//             </div>
//           </div>
//           <div className="blog__head">
//             <h2>Blog</h2>
//             <p>
//               Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
//               tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
//             </p>
//           </div>
//         </div>
//       </section>
//       <section className="blogBlock">
//         <div className="container flow-content">
//           <div className="blog__list split">
//             <div className="blog__listItem" id="blog_item1">
//               <button className="section-links">
//                 <img src={newssImage1} alt="" />
//               </button>
//               <button>
//                 <h4>Birthdays Decoration</h4>
//               </button>
//               <p>Lorem ipsum dolor sit amet</p>
//               <button className="section-links">
//                 <span>Read More</span>
//                 <span className="arrow__icon">
//                   <BsArrowRight />
//                 </span>
//               </button>
//             </div>
//             <div className="blog__listItem" id="blog_item2">
//               <button>
//                 <img src={newssImage2} alt="" />
//               </button>
//               <button>
//                 <h4>Birthdays Decoration</h4>
//               </button>
//               <p>Lorem ipsum dolor sit amet</p>
//               <button className="section-links">
//                 <span>Read More</span>
//                 <span className="arrow__icon">
//                   <BsArrowRight />
//                 </span>
//               </button>
//             </div>
//             <div className="blog__listItem" id="blog_item3">
//               <button>
//                 <img src={newssImage3} alt="" />
//               </button>
//               <button>
//                 <h4>Birthdays Decoration</h4>
//               </button>
//               <p>Lorem ipsum dolor sit amet</p>
//               <button className="section-links">
//                 <span>Read More</span>
//                 <span className="arrow__icon">
//                   <BsArrowRight />
//                 </span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Blog;

import React from "react";
import { Link } from "react-router-dom";
import artperfection2 from "../../images/artperfection-2.jpg";
import artperfection1 from "../../images/artperfection-1.jpg";
import { BsArrowRight } from "react-icons/bs";
import { blogsdata, Blog as BlogType } from "../../blogs/blogData";
// ✅ this works now
import "./blog.css";

const Blog = () => {
  return (
    <>
      <section className="blog bg-accent">
        {" "}
        <div className="container split flow-content">
          {" "}
          <div className="blog__img">
            {" "}
            <div className="blog__imgBox1">
              <img src={artperfection2} alt="" />{" "}
            </div>{" "}
            <div className="blog__imgBox2">
              <img src={artperfection1} alt="" />{" "}
            </div>{" "}
          </div>{" "}
          <div className="blog__head">
            <h2>Blog</h2>{" "}
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit
              tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.{" "}
            </p>{" "}
          </div>{" "}
        </div>{" "}
      </section>
      <section className="blogBlock">
        <div className="container flow-content">
          <div className="blog__list split">
            {blogsdata.map((blog: BlogType) => (
              <div key={blog.id} className="blog__listItem">
                <Link to={`/blog/${blog.id}`} className="section-links">
                  <img src={blog.image} alt={blog.title} /> {/* ✅ correct */}
                </Link>
                <Link to={`/blog/${blog.id}`}>
                  <h4>{blog.title}</h4>
                </Link>
                <p>{blog.date}</p>
                <Link to={`/blog/${blog.id}`} className="section-links">
                  <span>Read More</span>
                  <span className="arrow__icon">
                    <BsArrowRight />
                  </span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
